<!--*** other categories ***-->
<div class="grid grid-cols-5 gap-[10px]">
  <!-- re -->
  <div class="border border-solid border-gray-300 group">
    <a href="#">
      <div class="p-[10px] flex justify-center">
        <img
          src="../../../assets/assets-new/images/product/demo-1.jpg"
          class="h-[100px] object-contain"
        />
      </div>
      <div
        class="text-center p-[10px] bg-[#D0F0C0] group-hover:bg-[#162F4D] text-[#000] group-hover:text-[#fff]"
      >
        <span class="line-clamp-1"
          >Storage & Workspace Storage & WorkspaceStorage & Workspace</span
        >
      </div>
    </a>
  </div>
  <!-- re /-->

  <!-- re -->
  <div class="border border-solid border-gray-300 group">
    <a href="#">
      <div class="p-[10px] flex justify-center">
        <img
          src="../../../assets/assets-new/images/product/demo-1.jpg"
          class="h-[100px] object-contain"
        />
      </div>
      <div
        class="text-center p-[10px] bg-[#D0F0C0] group-hover:bg-[#162F4D] text-[#000] group-hover:text-[#fff]"
      >
        <span class="line-clamp-1">Storage & Workspace </span>
      </div>
    </a>
  </div>
  <!-- re /-->

  <!-- re -->
  <div class="border border-solid border-gray-300 group">
    <a href="#">
      <div class="p-[10px] flex justify-center">
        <img
          src="../../../assets/assets-new/images/product/demo-1.jpg"
          class="h-[100px] object-contain"
        />
      </div>
      <div
        class="text-center p-[10px] bg-[#D0F0C0] group-hover:bg-[#162F4D] text-[#000] group-hover:text-[#fff]"
      >
        <span class="line-clamp-1">Storage & Workspace </span>
      </div>
    </a>
  </div>
  <!-- re /-->

  <!-- re -->
  <div class="border border-solid border-gray-300 group">
    <a href="#">
      <div class="p-[10px] flex justify-center">
        <img
          src="../../../assets/assets-new/images/product/demo-1.jpg"
          class="h-[100px] object-contain"
        />
      </div>
      <div
        class="text-center p-[10px] bg-[#D0F0C0] group-hover:bg-[#162F4D] text-[#000] group-hover:text-[#fff]"
      >
        <span class="line-clamp-1">Storage & Workspace </span>
      </div>
    </a>
  </div>
  <!-- re /-->

  <!-- re -->
  <div class="border border-solid border-gray-300 group">
    <a href="#">
      <div class="p-[10px] flex justify-center">
        <img
          src="../../../assets/assets-new/images/product/demo-1.jpg"
          class="h-[100px] object-contain"
        />
      </div>
      <div
        class="text-center p-[10px] bg-[#D0F0C0] group-hover:bg-[#162F4D] text-[#000] group-hover:text-[#fff]"
      >
        <span class="line-clamp-1">Storage & Workspace </span>
      </div>
    </a>
  </div>
  <!-- re /-->
</div>

<!--*** other categories / ***-->
